module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b-lg",
    staticStyle: {
      "color": "#575757"
    }
  }, [_vm._v("LogBox for patients")]), _vm._v(" "), _c('div', {
    staticClass: "m-b m-t-3"
  }, [_c('h5', [_vm._v("\n                    Complete the forms online now.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "id": "openKioskLink"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("Search for your doctor")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Complete and share your information on the go")]), _vm._v(" "), _c('app-links', {
    attrs: {
      "appLinks": _vm.appLinks
    }
  })], 1)])]), _vm._v(" "), _c('kiosk-modal', {
    attrs: {
      "openModal": _vm.openKioskModal,
      "id": "kioskModal"
    },
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f2491d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/outputs/UnderConstructionDisplay.vue
// module id = 664
// module chunks = 5